<h2 mat-dialog-title>Atención</h2>
<div mat-dialog-content>
  <div *ngIf="data?.mensaje">
    {{data.mensaje}}
    <br><br>
  </div>

    ¿Desea confirmar esta operación?
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions align="end">
    <button mat-button  mat-dialog-close>Cerrar</button>
    <button mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Si</button>
</div>

